<div id="historyDialog" class="modal modal-lg modal-dialog fade in" role="dialog" style="display: none;" appDraggable dragTarget="#historyDialog" dragHandle="#historyDialogHeader">
  <div class="modal-content">
    <div class="modal-header" id="historyDialogHeader">
      HISTORY QUERY
    </div>

    <div class="modal-body internal-well">
      <div>{{ statusText }}</div>
      <div><progress id="historyDialogProgressBar" value="{{ percentageDone }}" max="100"></progress> {{ percentageDone }} %</div>
    </div>


    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="cancel()"><i class="fa fa-ban" aria-hidden="true"></i> CANCEL</button>
      <button type="button" class="btn btn-primary" (click)="hide()" [disabled]="!okButtonEnabled"><i class="fa fa-ban" aria-hidden="true"></i> OK</button>
    </div>
  </div>
</div>

